import type { IconData } from '@stacksjs/iconify-core'

export const candleSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24.812 1.173c.486.49.738 1.17.71 1.857c-.049 1.173-.03 2.666.206 4.076c.215 1.283.585 2.332 1.108 3.029c.214-.229.443-.557.675-1c.329-.629.61-1.387.844-2.186a2.55 2.55 0 0 1 1.79-1.755a2.38 2.38 0 0 1 2.493.823c1.604 2.011 2.862 4.598 2.862 7.737c0 3.293-1.321 5.812-3.532 7.461c-2.15 1.605-5.003 2.287-7.968 2.287s-5.818-.682-7.968-2.287c-2.21-1.65-3.532-4.168-3.532-7.461c0-6.635 5.562-10.768 8.543-12.53A5.9 5.9 0 0 1 22.694.56c.837-.195 1.61.1 2.118.613m8.58 24.396c3.015-.104 5.703 2.014 5.937 5.173a68 68 0 0 1 .171 5.027V46a1.5 1.5 0 0 1-1.5 1.5H10A1.5 1.5 0 0 1 8.5 46v-8.184c0-1.687.07-3.116.168-4.282c.245-2.958 2.474-5.156 5.246-5.714c6.21-1.248 12.943-2.025 19.478-2.25\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default candleSolid
